import React, { useEffect } from 'react';
import scrollToTop from '../utilities/scrollToTop';


const Faq = () => {
  useEffect(()=>{
    scrollToTop();
  })
  const faqData = [
    {
      question: 'How do I know the medicines delivered are authentic?',
      answer: `The product is being supplied directly by the vendors associated with the Company and the Vendor concerned shall solely be responsible for the authenticity and genuineness of the product so ordered.`,
    },
    {
      question: 'Where can I check my order status?',
      answer: `You will receive regular SMS & Emails about your order. You can also track your order from your order history section. If there is any delay or change in your order, our customer care will call and inform you.`,
    },
    {
      question: 'What is your cancellation policy?',
      answer: `You can cancel your order till we ship it. Orders once shipped cannot be cancelled.`,
    },
    {
      question: 'If I upload a prescription, will my order be confirmed immediately?',
      answer: `No. After the prescription is validated, the vendor will confirm stock availability. You will receive an SMS and email if any medicines cannot be fulfilled. As a lead generation platform, the site connects you to a pharmacy that confirms the order after verifying credentials and the prescription.`,
    },
    {
      question: 'Will I need the original prescription at time of delivery?',
      answer: `Yes. Per government regulations, the patient must possess the original prescription at the time of delivery. Please keep it handy for the delivery personnel.`,
    },
    {
      question: 'Why do the prices of medicine vary?',
      answer: `Prices vary by geographical location and can change daily due to regulations and distributors. The prices listed on the site act as guidance to help you understand if you are paying the right price.`,
    },
    {
      question: 'Where can I check my order status?',
      answer: `You will receive regular SMS and emails. You can also track the order in your order history section. Customer care will call you if there are any delays or changes.`,
    },
    {
      question: 'What is your cancellation policy?',
      answer: `You can cancel an order until it is shipped. Once shipped, orders cannot be cancelled.`,
    },
    {
      question: 'What is your return policy?',
      answer: `Returns are accepted if the medicine does not match the order or is past its expiry date. Refund requests must be made within seven days of delivery.`,
    },
    {
      question: 'Is MediiApp a pharmacy?',
      answer: `No, MediiApp helps you connect to the nearest partnered pharmacy that can fulfill your order. They partner with verified pharmacies that work with registered pharmacists.`,
    },
     {
      question: 'So, how will I get my medicines?',
      answer: `The prescription you provide is validated by a team of pharmacists and then passed on to a pharmacy in your vicinity. The sale of medicines can only be done by a licensed pharmacy under the supervision of a pharmacist.`,
    },
    {
      question: 'How does my prescription get validated?',
      answer: `They check if a registered medical practitioner generated the prescription. They also look at the date of visit and duration of medication to ensure it hasn't expired, and verify that the quantity ordered matches the prescription.`,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center mt-10 mb-10">
      <div className="bg-white shadow-xl sm:max-w-3xl sm:rounded-lg sm:px-10 w-full flex-1">
        <div className="mx-auto px-5 py-5
        ">
          <div className="flex flex-col items-center">
            <h2 className="text-3xl font-bold tracking-tight md:text-5xl">FAQ</h2>
            <p className="mt-3 text-lg text-gray-600 md:text-xl">Frequently asked questions</p>
          </div>
          <div className="mt-8  divide-y divide-gray-200">
            {faqData.map((faq, index) => (
              <FaqItem key={index} question={faq.question} answer={faq.answer} />
            ))}
          </div>
        </div>
      </div>
      {/* Your footer component here */}
    </div>
  );
};

const FaqItem = ({ question, answer }) => {
  return (
    <div className="py-5">
      <details className="group">
        <summary className="flex cursor-pointer list-none items-center justify-between font-medium">
          <span>{question}</span>
          <span className="transition-transform group-open:rotate-180">
            <svg
              fill="none"
              height="24"
              shapeRendering="geometricPrecision"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              width="24"
            >
              <path d="M6 9l6 6 6-6"></path>
            </svg>
          </span>
        </summary>
        <p className="group-open:animate-fadeIn mt-3 text-gray-700">{answer}</p>
      </details>
    </div>
  );
};

export default Faq;
